import { render, staticRenderFns } from "./ProdutosView.vue?vue&type=template&id=d4d8c2e2&scoped=true"
import script from "./ProdutosView.vue?vue&type=script&lang=js"
export * from "./ProdutosView.vue?vue&type=script&lang=js"
import style0 from "./ProdutosView.vue?vue&type=style&index=0&id=d4d8c2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d8c2e2",
  null
  
)

export default component.exports